import Vue from "vue";
import ResourceService from "./resource.service";

class CompaniesService extends ResourceService {
  static get resource() {
    return "admin/businesses";
  }
  static getNewsletterPreview(params) {
    const url = `${this.resource}/newsletter`;

    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url,params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  /**
   * Fetch next page of businesses using the full URL (for paginated list_view).
   * @param {string} url - Full URL from API response (e.g. response.next)
   * @returns {Promise<{ count, next, previous, data }>}
   */
  static getByUrl(url) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url)
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  }
  static getCustomersForBusiness({ business_id, search = '', page = 1, page_size = 20 }) {
    const params = { business_id, page, page_size };
    if (search) params.search = search;
    const url = `/admin/customers`;
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, { params })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default CompaniesService;
